import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

/**
 * The root holds no chrome of its own. Each screen renders inside one of the
 * two frames — the pre-account frame on `/login`, the dashboard frame
 * everywhere else — and each frame owns its own skip link, banner and `main`
 * (`ux.md`, Layout / interaction notes).
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
});
